import React, { Component } from 'react';

export default class VolumeSlider extends Component {
  constructor(props) {
    super(props);
    const value = ('value' in props) ? props.value : 100;
    this.min = 0;
    this.max = 200;
    this.step = 1;
    this.state = { value };
  }

  onChange = (e) => {
    const value = parseInt(e.target.value, 10);
    this.setState({ value });
    this.props.onChange(value);
  }

  render = () => {
    return <section className="control slider length-slider">
      <label>Volume</label>
      <input type="range" min={this.min} step={this.step} max={this.max} value={this.state.value} onChange={this.onChange} />
      <input type="number" size="4" value={this.state.value} onChange={this.onChange} />
    </section>
  }
}


// WEBPACK FOOTER //
// ./src/components/VolumeSlider.js